export {CatalogPage} from './CatalogPage';
